/**
 * @module Container
 * @description
 */
import React, { FC } from 'react';
import useConditionalClasses from 'ui/hooks/useConditionalClasses';
import styles from './styles/Container.module.css';

interface Props {
  children: JSX.Element;
  weightedLeft?: boolean;
  weightedRight?: boolean;
  className?: string;
}

const Container: FC<Props> = ( {
  children,
  weightedLeft, weightedRight,
  className = ''
} ) => {
  const classes = { weightedLeft, weightedRight };
  const modifierClasses = useConditionalClasses( styles, classes );

  return (
    <div className={ `
      ${ styles.container }
      ${ modifierClasses }
      ${ className }
    ` }
    >
      { children }
    </div>
  );
};

export default Container;
